import React from "react";

/**
 * Function that defines a FilterIcon component.
 *
 * @return {JSX.Element} The FilterIcon component
 */
export const FilterIcon = () => {
  return (
    <svg
      width="17"
      height="19"
      viewBox="0 0 17 19"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M10.0468 19C9.87952 19 9.71678 18.9444 9.58298 18.8417L6.49108 16.4667C6.39508 16.3929 6.31716 16.2973 6.2635 16.1874C6.20983 16.0775 6.18189 15.9562 6.18189 15.8333V11.3842L0.758705 5.13554C0.373547 4.69053 0.122067 4.14106 0.0344894 3.55319C-0.0530881 2.96531 0.0269639 2.36404 0.265024 1.82164C0.503084 1.27924 0.889021 0.818788 1.37645 0.495635C1.86388 0.172483 2.43206 0.000375582 3.0127 0L13.9889 0C14.5695 0.000697499 15.1376 0.173089 15.6248 0.49646C16.112 0.81983 16.4977 1.28042 16.7355 1.82288C16.9733 2.36534 17.0531 2.96659 16.9653 3.55438C16.8775 4.14217 16.6259 4.69149 16.2406 5.13633L10.8197 11.3842V18.2083C10.8197 18.4183 10.7383 18.6197 10.5933 18.7681C10.4484 18.9166 10.2518 19 10.0468 19ZM7.72784 15.4375L9.27379 16.625V11.0833C9.27395 10.8895 9.34353 10.7025 9.46935 10.5577L15.0873 4.08421C15.2747 3.86736 15.3969 3.59974 15.4394 3.31348C15.4818 3.02723 15.4428 2.7345 15.3268 2.47044C15.2108 2.20638 15.0229 1.98222 14.7856 1.82486C14.5483 1.6675 14.2716 1.58364 13.9889 1.58333H3.0127C2.73014 1.58377 2.4537 1.66768 2.21654 1.825C1.97938 1.98232 1.79156 2.20637 1.67561 2.47028C1.55967 2.73418 1.52051 3.02675 1.56285 3.31287C1.60519 3.599 1.72722 3.86654 1.9143 4.08342L7.53305 10.5577C7.6586 10.7026 7.7279 10.8896 7.72784 11.0833V15.4375Z"
        fill="currentColor"
      />
    </svg>
  );
};
